import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SidebarAccountComponent } from './sidebar-account.component';
import { RouterModule } from '@angular/router';
import { CompaniesModule } from '../companies/companies.module';
import { ReportsModule } from '../reports/reports.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        CompaniesModule,
        ReportsModule
    ],
    declarations: [SidebarAccountComponent],
    exports: [SidebarAccountComponent]
})
export class SidebarAccountModule {}
